import React, { useState } from "react";
import api from '../../services/api';
import { Modal, Col, Row, Form } from 'react-bootstrap';
import DatePicker from '../../components/DatePicker';
import Slct from '../../components/Slct'
import { Currency } from "../../components/Input";
import IcX from '../../components/Svg/IcX';
import styles from './style.module.css';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import Button from '../../components/Button';
import useWrapper from "../../hooks/useWrapper";

export default function ModalPayment(props) {
  const { payment, setPayment, closeModal, reload, setReload, commercials, providers, costCenter, methods, setmethods } = props;

  const { me, config } = useWrapper();
  const permissions = JSON.parse(me.permissions);

  const createSchema = yup.object().shape({
    user_id: yup.string().required("Algo deu errado, tente novamente."),
    type_payment: yup.string().required("Por favor, selecione o Tipo de Pagamento"),
    value: yup.string().required("Por favor, selecione o Valor do Pagamento"),
    due_date: yup.string().required("Por favor, insira a Data do Pagamento"),
    expense_id: yup.string().required("Por favor, selecione a Conta"),
    expense_plan_id: yup.string().required("Por favor, selecione o Plano de Conta"),
    cost_center_id: yup.string().required("Por favor, selecione o Centro de Custo"),
  })

  const addPayment = () => {

    let _values = {
      cost_center_id: payment.cost_center_id || "",
      expense_plan_id: payment.expense_plan_id || "",
      expense_id: payment.expense_id || "",
      due_date: payment.due_date || "",
      value: payment.value || "",
      type_payment: payment.type_payment || "",
      provider_id: payment.provider_id || "",
      commercial_id: payment.commercial_id || "",
      user_id: me.id || "",
      description: payment.description || "",
      payment_for: !payment.payment_for ? "empresa" : "turma"
    }

    createSchema.validate(_values)
      .then(() => {
        setloadingRequest(true);
        if (!payment.bill) {
          api.post("bills-to-pay", _values, config)
            .then(() => {
              setloadingRequest(false);
              toast.success("Pagamento gerado com sucesso!");
              closeModal();
              setReload(!reload);
            })
        }
        else {
          api.put(`bills-to-pay/${payment.bill}`, _values, config)
            .then(() => {
              setloadingRequest(false);
              toast.success("Pagamento editado com sucesso!");
              closeModal();
              setReload(!reload);
            })
        }
      })
      .catch(function (err) {
        toast.error(err.message);
      })
  }

  const [loadingRequest, setloadingRequest] = useState(false);

  return (
    <Modal size="lg" show={!!payment} onHide={closeModal}>
      <Modal.Header>
        <div as="label" className="d-flex w-100">
          <h2 className="page-title">{payment && payment.bill ? "Editar Pagamento" : "Gerar Pagamento"}</h2>
        </div>
        <button className={styles.closeModal} onClick={closeModal}>
          <IcX />
        </button>
      </Modal.Header>
      <Modal.Body>
        {payment && (
          <>
            <Row>
              <Col sm={4}>
                <Form.Group>
                  <span className='lince-input_label'>Pagamento referente à</span>
                  <Slct
                    placeholder="..."
                    value={payment.payment_for}
                    options={[
                      { value: null, label: "Empresa" },
                      ...(permissions.commercial.reading ? [{ value: "turma", label: "Turma" }] : [])
                    ]}
                    onChange={ev => {
                      setPayment({
                        ...payment,
                        payment_for: ev.value
                      })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className='mt-2'>
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">Centro de Custo</span>
                  <Slct
                    isDisabled={payment && payment.bill}
                    placeholder="..."
                    value={payment.cost_center_id}
                    options={costCenter}
                    name="cost_center_id"
                    onChange={ev => {
                      setPayment({
                        ...payment,
                        cost_center_id: ev.value,
                        expense_plan_id: null,
                        expense_id: null
                      })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">Plano de Conta</span>
                  <Slct
                    isDisabled={payment && payment.bill}
                    placeholder="..."
                    value={payment.expense_plan_id}
                    options={payment.cost_center_id ? costCenter.find(e => e.value === payment.cost_center_id).expense_plans : []}
                    onChange={ev => {
                      setPayment({
                        ...payment,
                        expense_plan_id: ev.value,
                        expense_id: null
                      })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={4}>
                <Form.Group>
                  <span className="lince-input_label">Conta</span>
                  <Slct
                    isDisabled={payment && payment.bill}
                    placeholder="..."
                    value={payment.expense_id}
                    options={(payment.cost_center_id && payment.expense_plan_id) ? costCenter.find(e => e.value === payment.cost_center_id).expense_plans.find(e => e.value === payment.expense_plan_id).expenses : []}
                    onChange={ev => {
                      setPayment({
                        ...payment,
                        expense_id: ev.value
                      })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={4} className='mt-2'>
                <Form.Group>
                  <span className='lince-input_label'>Vencimento</span>
                  <DatePicker
                    disabled={payment && payment.bill}
                    selected={payment.due_date}
                    changeDate={ev => {
                      setPayment({
                        ...payment,
                        due_date: ev
                      })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={4} className='mt-2'>
                <Form.Group>
                  <span className="lince-input_label">Valor</span>
                  <Currency
                    disabled={payment && payment.bill}
                    value={payment.value}
                    valueChange={ev => {
                      setPayment({
                        ...payment,
                        value: ev
                      })
                    }}
                  />
                </Form.Group>
              </Col>
              <Col sm={4} className='mt-2'>
                <Form.Group>
                  <span className="lince-input_label">Método</span>
                  <Slct
                    isDisabled={payment && payment.bill}
                    placeholder="..."
                    value={payment.type_payment}
                    options={methods}
                    onChange={ev => {
                      setPayment({
                        ...payment,
                        type_payment: ev.value
                      })
                    }}
                  />
                </Form.Group>
              </Col>
              {permissions.suppliers.reading && (
                <Col sm={6} className='mt-2'>
                  <Form.Group>
                    <span className="lince-input_label">Fornecedor</span>
                    <Slct
                      isDisabled={payment && payment.bill}
                      placeholder="..."
                      value={payment.provider_id}
                      options={providers}
                      onChange={ev => {
                        setPayment({
                          ...payment,
                          provider_id: ev.value
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
              {permissions.commercial.reading && (
                <Col sm={6} className='mt-2'>
                  <Form.Group>
                    <span className="lince-input_label">Turma</span>
                    <Slct
                      isDisabled={payment && payment.bill}
                      placeholder="..."
                      value={payment.commercial_id}
                      options={commercials}
                      onChange={ev => {
                        setPayment({
                          ...payment,
                          commercial_id: ev.value
                        })
                      }}
                    />
                  </Form.Group>
                </Col>
              )}
              <Col sm={12} className='mt-2'>
                <Form.Group>
                  <span className="lince-input_label">Descrição</span>
                  <input
                    disabled={payment && payment.bill}
                    type="text"
                    value={payment.description}
                    onChange={ev => {
                      setPayment({
                        ...payment,
                        description: ev.target.value
                      })
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="primary_ghost"
          onClick={() => closeModal()}
        >
          {payment && payment.bill ? "Fechar" : "Cancelar"}
        </Button>
        {payment && payment.bill ? (
          <></>
        ) : (
          <Button
            loading={loadingRequest}
            onClick={() => addPayment()}
          >
            Gerar Pagamento
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  )
}
